import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  of,
  throwError,
} from "rxjs";

import { Auth } from "../models/auth";
import { environment } from "src/environments/environment.prod";
import { Router } from "@angular/router";

const AUTH_API = `${environment.authApiUrl}/api/v1/auth`;

const AUTH_API_USERS = `${environment.authApiUrl}/api/v1/users`;



const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
  withCredentials: true,
};

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient, private router: Router) {}

  headers = new HttpHeaders().set("Content-Type", "application/json");

  login(data: any): Observable<any> {
    let CREATE_URL = `${AUTH_API}/signin`;
    return this.http
      .post(CREATE_URL, data, {
        observe: "response",
        headers: this.headers,
        withCredentials: true,
      })
      .pipe(
        map((res) => {
          return res || {};
        })
      );
  }
  signup(data: any): Observable<any> {
    let CREATE_URL = `${AUTH_API_USERS}/create`;
    return this.http
      .post(CREATE_URL, data, {
        observe: "response",
        headers: this.headers,
        withCredentials: true,
      })
      .pipe(
        map((res) => {
          return res || {};
        })
      );
  }

  verifyOTP(params: any): Observable<any> {
    const OTP_URL = `${AUTH_API}/otp/verify`;

    return this.http.get<any>(OTP_URL, {
      params,
    });
  }

  
  updatePassword(resetPasswordDetails): Observable<any> {
    const updatePasswordUrl = `${AUTH_API}/reset-password`;

    return this.http.post<any>(updatePasswordUrl, resetPasswordDetails);
  }

  forgotPassword(email): Observable<any> {
    const resetPasswordUrl = `${AUTH_API}/forgot-password`;

    return this.http.post<any>(resetPasswordUrl, email);
  }

  getProfileUpdateStatus(params:any){
    let API_URL = `${AUTH_API_USERS}/check/by/email`;
    return this.http.get(API_URL,{params:params, headers: this.headers, withCredentials: false }).pipe(map(res => {
          return res || {}
        }) 
        )
  }

  refreshAccessToken(refreshToken: string): Observable<any> {
    const REFRESH_URL = `${AUTH_API}/refreshtoken`;

    console.log("Checking for: ", refreshToken);

    let refreshTokenReq = { refreshToken: refreshToken };

    return this.http.post<any>(REFRESH_URL, refreshTokenReq);
  }

  logout(refreshToken: string): Observable<any> {
    const LOGOUT_URL = `${AUTH_API}/logout`;

    const requestParams = new HttpParams().set("refreshToken", refreshToken);

    return this.http.put<any>(LOGOUT_URL, {}, { params: requestParams });
  }


  // Error handling
  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `${error.error.message}`;
    }
    return throwError(errorMessage);
  }
}
